import { Grid, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { apiUrl } from "../../../../../common/constants/apiUrl";
import { LanguagesEnum_class } from "../../../../../common/enums/languages";
import { ExhibitDto } from "../../../../exhibits/exhibits.dtos";

interface IProps {
  exhibit: ExhibitDto;
}

const ExhibitCard: React.FC<IProps> = ({ exhibit }) => {
  const [thumbnail, setThumbnail] = useState("");

  useEffect(() => {
    setThumbnail(`${apiUrl}/exhibits/thumbnail/${exhibit.thumbnail}`);
  }, [exhibit.thumbnail]);

  return (
    <Grid
      container
      direction="row"
      alignItems="flex-start"
      style={{
        borderBottom: "1px solid black",
        padding: 0,
        maxHeight: "200px",
        overflowY: "scroll",
      }}
    >
      <Grid item style={{ marginRight: "10px" }}>
        <img src={thumbnail} style={{ width: "10rem" }} />
      </Grid>
      <Grid item>
        <Typography variant="h6" style={{ fontWeight: "bold" }}>
          {exhibit.name}
        </Typography>
        {exhibit.content
          .filter((x) => x.languageId === LanguagesEnum_class.enum.English)
          .map((x) => (
            <Typography
              key={x.id}
              dangerouslySetInnerHTML={{ __html: x.content }}
            ></Typography>
          ))}
      </Grid>
    </Grid>
  );
};

export default ExhibitCard;
